import * as React from 'react'

export function ExternalLinkIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M9 9.5L16.875 1.625"
        stroke="#33333C"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M9 1.625H16.875V9.5"
        stroke="#33333C"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
      <path
        d="M6.93639 4.4375H1.125V17.375H14.0625V11.5636"
        stroke="#33333C"
        stroke-width="1.5"
        stroke-miterlimit="10"
      />
    </svg>
  )
}
